import React, { useEffect, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import { getPublicImagePath } from '@nutastic/nutastic-react-app';

const MusicPlayer = () => {
    const componentClass = 'musicPlayer';
    const [currentTrack, setTrackIndex] = useState(0);

    const playlist = [
        { name: "Ain't No BnB", src: getPublicImagePath('kite/_tracks/1_bnb.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Hot Dr. Pepper", src: getPublicImagePath('kite/_tracks/2_pepper.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Spoil Her Alert!", src: getPublicImagePath('kite/_tracks/3_spoil.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Duck Duck Golden Goose", src: getPublicImagePath('kite/_tracks/4_duck.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Last Man On The Bench", src: getPublicImagePath('kite/_tracks/5_bench.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Grown In Living Soil", src: getPublicImagePath('kite/_tracks/6_soil.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') },
        { name: "Janky Dice", src: getPublicImagePath('kite/_tracks/7_dice.mp3'), cover: getPublicImagePath('kite/kite-small.JPEG') }
    ];

    useEffect(() => {
        if ('mediaSession' in navigator) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: playlist[currentTrack].name,
                artist: 'Quistar',
                album: 'QuistarGo.com',
                artwork: [
                    { src: playlist[currentTrack].cover, sizes: '512x512', type: 'image/png' }
                ]
            });
        }
    }, [currentTrack]);

    const handleClickPrevious = () => {
        setTrackIndex(currentTrack => currentTrack > 0 ? currentTrack - 1 : 0);
    };

    const handleClickNext = () => {
        setTrackIndex(currentTrack => currentTrack < playlist.length - 1 ? currentTrack + 1 : 0);
    };

    const handleEnd = () => {
        setTrackIndex(currentTrack => currentTrack < playlist.length - 1 ? currentTrack + 1 : 0);
    };

    return <div className={componentClass}>
        <AudioPlayer
            volume="0.5"
            autoPlay={false}
            src={ playlist[currentTrack].src }
            showJumpControls={false}
            showSkipControls={true}
            showDownloadProgress={false}
            loop={false}
            layout={'horizontal-reverse'}
            customVolumeControls={[]}
            customAdditionalControls={[]}
            showFilledVolume={false}
            onClickNext={handleClickNext}
            onClickPrevious={handleClickPrevious}
            onEnded={handleEnd}
        />
    </div>;
};

export default MusicPlayer;
